import { render, staticRenderFns } from "./BudgetLoanTablePage.vue?vue&type=template&id=222379a8&"
import script from "./BudgetLoanTablePage.vue?vue&type=script&lang=ts&"
export * from "./BudgetLoanTablePage.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetLoanTablePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports